import React from 'react';
import { jsx } from '@emotion/core';
import moment from 'moment';
import { IAssetAllocation } from '../../../utils/types';
import DataTable from '../../../components/table/DataTable';
/**@jsx jsx*/

type Actions = { label: string; action: (allocation: any) => void }[];

interface IProps {
  allocations?: IAssetAllocation[];
  actions: Actions;
  isLoading?: boolean;
}

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Product',
    dataIndex: 'product',
    key: 'product',
  },
  {
    title: 'Duration',
    dataIndex: 'duration',
    key: 'duration',
  },
  {
    title: 'Weight',
    dataIndex: 'weight',
    key: 'weight',
  },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (createdAt: Date) => {
      return <span>{moment(createdAt).format('DD/MM/YYYY')}</span>;
    },
  },
  {
    title: 'Last Changed',
    dataIndex: 'lastChanged',
    key: 'lastChanged',
    render: (lastChanged: Date) => {
      return <span>{moment(lastChanged).format('DD/MM/YYYY')}</span>;
    },
  },
];

const AllocationsTable: React.FC<IProps> = ({
  allocations = [],
  actions,
  isLoading,
}) => {
  return (
    <DataTable
      isLoading={isLoading}
      showControls
      showPagination
      data={allocations}
      columns={columns}
      actions={actions}
      searchFilter="product"></DataTable>
  );
};

export default AllocationsTable;
